import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'aaos-dino-spinner',
  templateUrl: './dino-spinner.component.html',
  styleUrls: ['./dino-spinner.component.scss']
})
export class DinoSpinnerComponent {
  @Input() isLoading$: BehaviorSubject<boolean>;
  @Input() isLoading: boolean;
  @Input() displayInline: boolean;
  @Input() spinnerCaption: string;
}
